import React from 'react';

import InlineCode from '~/components/InlineCode.react';
import SectionCode from '~/components/SectionCode.react';
import SectionDescription from '~/components/SectionDescription.react';
import SectionTitle from '~/components/SectionTitle.react';

import { disabledButtonReversedCode } from '~/components/CodeSnippets.js';

export default function DisabledButtonReversed() {
    return (
        <section className="marginBottom-xl">
            <div className="marginBottom-m breakPointM-marginBottom-l">
                <SectionTitle sectionTitle={"Disabled button on dark background"} />

                <SectionDescription>
                    This is the reversed version of disabled buttons which is meant
                    to be used on dark backgrounds or reversed themes. The reversed theme is applied with the class <InlineCode>.is-reversed</InlineCode>.
                </SectionDescription>
            </div>

            <div className="padding-m textAlign-center bg-steel borderRadiusTop-m breakPointM-inline breakPointM-textAlign-left">
                <div>
                    <button
                        className="button button--m button--flat bg-marvel is-disabled is-reversed"
                        type="button"
                        disabled>
                        Disabled
                    </button>
                </div>
            </div>

            <SectionCode codeType="language-html" code={disabledButtonReversedCode} />
        </section>
    );
}



/** WEBPACK FOOTER **
 ** ./src/site/js/pages/components/buttons/DisabledButtonReversed.react.js
 **/